// import hoja de estilo (css)
import "./SidebarReact.css";

// import hooks
import React, { useContext, useState, useEffect } from "react";

// import context
import { DarkModeContext } from "../../context/DarkModeContext";

// import librerias<FontAwesomeIcon icon={faTableCellsRowUnlock} /> <FontAwesomeIcon icon={faTableCells} />
import {
  faAnglesLeft,
  faAnglesRight,
  faRectangleList,
    faNewspaper,
    faTableCells,
    faClipboardCheck,
  faBell,
  faCalculator,
  faCertificate,
  faChartSimple,
  faCheck,
  faCheckToSlot,
  faCircle,
  faCommentDots,
  faFileArrowDown,
  faFileInvoiceDollar,
  faFileLines,
  faGear,
  faGraduationCap,
  faHouse,
  faLink,
  faList,
  faListCheck,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMoon,
  faReceipt,
  faRightFromBracket,
  faStar,
  faSun,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink, useLocation } from "react-router-dom";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Swal from "sweetalert2";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Badge } from "react-bootstrap";

// import assets
import qrCodigo from "../../assets/img/qrcodigo.png";
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";

// import componentes
import ModalConfiguraciones from "./ModalConfiguraciones";
import NotificacionIndicador from "./NotificacionIndicador";
import { getToken } from "../../utils/auth";


const SidebarReact = ({ esDemo = false }) => {
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.localStorage.getItem("sidebar_collapsed_desktop") === "1";
  });
  // estado para controlar la visibilidad del contenido del icono del campana
  const [visible1, setVisible1] = useState(false);

  // estado para controlar la visibilidad del contenido del icono del tuerca
  // para el cambio de contraseÃ±a
  const [visible2, setVisible2] = useState(false);

  // api url
  const apiUrlNotificaciones = process.env.REACT_APP_API_NOTIFICACIONES;
  const apiUrlLogout = process.env.REACT_APP_API_LOGOUT;

  // estado para guardar las notificaciones que consulto desde el back
  const [notificaciones, setNotificaciones] = useState([]);

  // estado para guardar las notificaciones que consulto desde el back
  const [notificacionesAliados, setNotificacionesAliados] = useState([]);
  const [notificacionesAsesores, setNotificacionesAsesores] = useState([]);

  // consulta para guardar las notificaciones
  // y filtro para los aliados y asesores
    useEffect(() => {
        const fetchNoticias = async () => {
            try {
                const response = await fetch(apiUrlNotificaciones);

                // Verificar que la respuesta sea "ok"
                if (!response.ok) {
                }

                const data = await response.json();

                // Verificar que data no estÃ© vacÃ­o
                if (!data || data.length === 0) {
                    return;
                }

                // Filtrar notificaciones por tipo de usuario
                const noticiasAliados = data.filter(
                    (notificacion) => notificacion.tipoUsuario.trim() === "Aliado"
                );
                const noticiasAsesores = data.filter(
                    (notificacion) => notificacion.tipoUsuario.trim() === "Asesor"
                );

                // Actualizar estados con notificaciones filtradas
                setNotificacionesAliados(noticiasAliados);
                setNotificacionesAsesores(noticiasAsesores);
            } catch (error) {
            }
        };

        fetchNoticias();
    }, [apiUrlNotificaciones]); 

  const cerrarSesion = () => {
    const token = getToken();
    if (!token) {
      console.error("No hay token en el almacenamiento de la sesiÃ³n");
      return;
    }
  
    // Eliminar el token del sessionStorage
    sessionStorage.removeItem("token");
  
    // Redireccionar al usuario, por ejemplo a la pÃ¡gina de inicio de sesiÃ³n
    window.location.href = "/";
  };

  // boton para abrir y ocultar el modal de notificaciones
  const verModalNotificacion = () => {
    setVisible1(!visible1);
    setVisible2(false);
  };

  // boton para abrir y ocultar el modal de cerrar sesion
  const verModalCerrarSesion = () => {
    setVisible2(!visible2);
    setVisible1(false);
  };

  const ocultarModalesInicio = () => {};
  const ocultarModalesContabilidad = () => { setVisible2(false); setVisible1(false); };
  const ocultarModalesAnalisis = () => { setVisible2(false); setVisible1(false); };
  const ocultarModalesTickets = () => { setVisible2(false); setVisible1(false); };
  const ocultarModalesCalculadora = () => { setVisible2(false); setVisible1(false); };
  const ocultarModalesCalificar = () => { setVisible2(false); setVisible1(false); };
  const ocultarModales = () => { setVisible2(false); setVisible1(false); };

  // darkMode context funcionalidad para el modo claro/oscuro
  const { darkMode } = useContext(DarkModeContext);

  //switch claro/oscuro
  const { toggleDarkMode } = useContext(DarkModeContext);

  // funcion para el claro/oscuro
  const handleClick = () => {
    toggleDarkMode();
  };

  const activadoIconoCampana = () => {
    if (visible1 && darkMode) {
      return " iconos-modales cursor-point text-white mx-3";
    } else if (visible1) {
      return " iconos-modales cursor-point text-dark mx-3";
    } else if (darkMode) {
      return "iconos-modales cursor-point  mx-3 color-verde";
    } else {
      return "iconos-modales cursor-point  mx-3 color-verde";
    }
  };

  const activadoIconoUser = () => {
    if (visible2 && darkMode) {
      return " iconos-modales cursor-point text-white mx-3";
    } else if (visible2) {
      return " iconos-modales cursor-point text-dark mx-3";
    } else if (darkMode) {
      return "iconos-modales cursor-point  mx-3 color-verde";
    } else {
      return "iconos-modales cursor-point  mx-3 color-verde";
    }
  };

  const getActiveClass = (isActive, darkMode) => {
    if (isActive) {
      return darkMode
        ? "d-flex btn-grid-active-dark"
        : "d-flex btn-grid-active";
    } else {
      return darkMode ? "d-flex btn-grid-dark" : "d-flex btn-grid";
    }
  };

  const normalizePath = (value) => {
    const path = String(value || "").toLowerCase().trim();
    if (!path || path === "/") return "/";
    return path.endsWith("/") ? path.slice(0, -1) : path;
  };

  const routeButtonClass = (pathOrPaths) => {
    const currentPath = normalizePath(location?.pathname);
    const candidates = Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths];
    const isActive = candidates
      .map((item) => normalizePath(item))
      .some((targetPath) => currentPath === targetPath || currentPath.startsWith(`${targetPath}/`));

    return getActiveClass(isActive, darkMode);
  };

  const crmPostventaPaths = [
    "/administracion/crm-postventa",
    "/administracion/crm-postventa/alertas",
    "/administracion/crm-postventa/ficha",
    "/administracion/crm-postventa/facturacion",
    "/administracion/crm-postventa/ordenes-pago",
    "/administracion/crm-postventa/cupones",
    "/administracion/crm-postventa/herramientas",
    "/administracion/crm-postventa/altas-bajas",
    "/administracion/crm-postventa/gestion",
    "/administracion/crm-postventa/seguimiento",
  ];

  const crmPostventaLinks = [
    {
      path: "/administracion/crm-postventa",
      label: "CRM Postventa",
      icon: faCertificate,
      activePaths: crmPostventaPaths,
    },
    {
      path: "/administracion/crm-postventa/alertas",
      label: "Alertas",
      icon: faBell,
    },
    {
      path: "/administracion/crm-postventa/altas-bajas",
      label: "Altas / Bajas",
      icon: faTableCells,
    },
    {
      path: "/administracion/crm-postventa/ficha",
      label: "Ficha del cliente",
      icon: faFileLines,
    },
    {
      path: "/administracion/crm-postventa/facturacion",
      label: "Facturación",
      icon: faChartSimple,
    },
    {
      path: "/administracion/crm-postventa/ordenes-pago",
      label: "Órdenes de pago",
      icon: faFileInvoiceDollar,
    },
    {
      path: "/administracion/crm-postventa/cupones",
      label: "Cupones",
      icon: faReceipt,
    },
    {
      path: "/administracion/crm-postventa/herramientas",
      label: "Herramientas",
      icon: faGear,
    },
    {
      path: "/administracion/crm-postventa/gestion",
      label: "Gestión",
      icon: faClipboardCheck,
    },
    {
      path: "/administracion/crm-postventa/seguimiento",
      label: "Seguimiento",
      icon: faListCheck,
    },
  ];

  const crmViejoLinksAdmin = [
    {
      path: "/administracion/crm-seguimiento",
      label: "CRM Seguimiento",
      icon: faCertificate,
    },
    {
      path: "/administracion/notificaciones",
      label: "Notificaciones",
      icon: faBell,
    },
    {
      path: "/administracion/popup",
      label: "Crear Modales",
      icon: faCertificate,
    },
    {
      path: "/administracion/blanqueos",
      label: "Blanqueos",
      icon: faFileInvoiceDollar,
    },
    {
      path: "/administracion/crm",
      label: "CRM",
      icon: faTableCells,
    },
    {
      path: "/administracion/legajos",
      label: "Legajos",
      icon: faNewspaper,
    },
    {
      path: "/admin/listaordenpago",
      label: "Órdenes de pago",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/nrocomercio",
      label: "Número comercio",
      icon: faRectangleList,
    },
    {
      path: "/administracion/bancos",
      label: "Bancos",
      icon: faRectangleList,
    },
    {
      path: "/administracion/AdminCupones",
      label: "Cupones",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/AdminResumenAliado",
      label: "Resumen aliado",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/AdminSimulador",
      label: "Comparador",
      icon: faChartSimple,
    },
    {
      path: "/administracion/AdminComparador",
      label: "Simulador",
      icon: faCalculator,
    },
    {
      path: "/admin/Simuladorliquidacion",
      label: "Simulador de órdenes",
      icon: faCalculator,
      activePaths: ["/admin/Simuladorliquidacion", "/admin/simuladorliquidacion"],
    },
    {
      path: "/admin/excepcion-anticipo",
      label: "Excepción anticipo",
      icon: faTableCells,
    },
    {
      path: "/admin/terminales-excepcion-anticipo",
      label: "Terminales anticipo",
      icon: faTableCells,
    },
  ];

  const crmViejoPathsAdmin = crmViejoLinksAdmin.flatMap((item) => {
    const paths = item.activePaths || item.path;
    return Array.isArray(paths) ? paths : [paths];
  });

  const isGroupActive = (pathOrPaths) => {
    const currentPath = normalizePath(location?.pathname);
    const candidates = Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths];
    return candidates
      .map((item) => normalizePath(item))
      .some((targetPath) => currentPath === targetPath || currentPath.startsWith(`${targetPath}/`));
  };

  const [crmViejoOpenAdmin, setCrmViejoOpenAdmin] = useState(false);

  useEffect(() => {
    if (isGroupActive(crmViejoPathsAdmin)) {
      setCrmViejoOpenAdmin(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("sidebar-collapsed", sidebarCollapsed);
    window.localStorage.setItem("sidebar_collapsed_desktop", sidebarCollapsed ? "1" : "0");

    return () => {
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [sidebarCollapsed]);

  const renderSidebarNavLink = ({ path, label, icon, activePaths, child = false }) => (
    <div className={`centrado my-2${child ? " crm-menu-child" : ""}`} key={path}>
      <NavLink
        end
        to={path}
        className="border-0 text-decoration-none"
        onClick={ocultarModalesContabilidad}
      >
        <div style={{ width: "160px" }}>
          <div className={routeButtonClass(activePaths || path)}>
            <div className="icono">
              <FontAwesomeIcon icon={icon} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">{label}</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );

  const [modalShowCompleta, setModalShowCompleta] = React.useState(false);
  const [hayNotificacionesNoVistas, setHayNotificacionesNoVistas] =
    useState(true);
  const [usuarioRol, setUsuarioRol] = useState();
  const [tieneOperaciones, setTieneOperaciones] = useState(false);
  const [tienePagosNaranja, setTienePagosNaranja] = useState(false);
  const apiUrlToken = process.env.REACT_APP_API_TOKEN;


  useEffect(() => {
    const verificarSeccionesAliado = async () => {
      const token = getToken();
      if (!token) return;
      try {
        const [resCobros, resNaranja] = await Promise.all([
          fetch("/api/aliadooperaciones/cobros-programados/tiene-acceso", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Token: token }),
          }),
          fetch("/api/aliadooperaciones/pagos-naranja/meses-disponibles", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Token: token }),
          }),
        ]);
        if (resCobros.ok) {
          const data = await resCobros.json();
          setTieneOperaciones(data === true);
        }
        if (resNaranja.ok) {
          const data = await resNaranja.json();
          setTienePagosNaranja(Array.isArray(data) && data.length > 0);
        }
      } catch (_) {}
    };
    verificarSeccionesAliado();
  }, []);

  useEffect(() => {
    const verificarToken = async () => {
      const token = getToken();

      try {
        const response = await fetch(apiUrlToken, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: token }),
        });

        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }

        const datosRecibido = await response.json();
        setUsuarioRol(datosRecibido);
        // AquÃ­ puedes hacer algo con el rol
        // Por ejemplo, guardarlo en el estado o realizar alguna lÃ³gica basada en el rol
      } catch (error) {
        console.error("Error al validar el token", error);
      }
    };

    verificarToken();
  }, [usuarioRol]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  const confirmarCerrarSesion = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      imageUrl: logo,
      imageWidth: 100,
      imageHeight: 30,
      imageAlt: "Logo",
      showCancelButton: true,

      confirmButtonText: "Sí",
      cancelButtonText: "No",
      customClass: {
        container: darkMode
          ? "swal2-container--dark"
          : "swal2-container--light",
        confirmButton: "my-swal-button",
        cancelButton: "my-swal-button2",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        cerrarSesion();
      }
    });
  };

  const menusPorRol = {
     // Aliados menu
    0: (
      <>
        <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/inicio"
            className=" border-0"
            onClick={ocultarModalesInicio}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/inicio")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faHouse} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Inicio</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/contabilidad"
            className=" border-0"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/contabilidad")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileInvoiceDollar} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14"> Contabilidad</span>
                  {/*<Badge className="custom-badge" bg="danger">*/}
                  {/*  Nuevo*/}
                  {/*</Badge>*/}
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/analisis"
            className=" border-0"
            onClick={ocultarModalesAnalisis}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/analisis")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Analisis</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/cupones"
            className=" border-0"
            onClick={ocultarModalesTickets}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/cupones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faReceipt} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Cupones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/calificar"
            className=" border-0"
            onClick={ocultarModalesCalificar}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/calificar")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faStar} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Calificar</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/consultas"
            className=" border-0"
            onClick={ocultarModalesCalificar}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/consultas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheckToSlot} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Consultas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/calculadora"
            className=" border-0"
            onClick={ocultarModalesCalificar}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/calculadora")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Simulador</span>
                  {/*<Badge className="custom-badge" bg="danger">*/}
                  {/*  Nuevo*/}
                  {/*</Badge>*/}
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        </>
        <div className="centrado my-2">
          <NavLink
            end
            to="/aliados/buscador-cupones-interno"
            className=" border-0"
            onClick={ocultarModales}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/aliados/buscador-cupones-interno")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faReceipt} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Buscador de cupones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        {esDemo && (
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/cobros-programados"
              className=" border-0"
              onClick={ocultarModales}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/cobros-programados")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faFileInvoiceDollar} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Cobros program.</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
        )}
        {esDemo && (
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/pagos-naranja"
              className=" border-0"
              onClick={ocultarModales}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/pagos-naranja")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faCertificate} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Pagos Naranja</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
        )}
        <div
          className={
            visible1 === true || visible2 === true
              ? " text-center"
              : " text-center"
          }
        >
          <div className="centrado my-2" onClick={ocultarModales}></div>
          <div className="centrado my-2" onClick={ocultarModales}>
            <a
              href="https://wa.link/w4quzx"
              target="_blank"
              rel="noreferrer"
              className=" border-0 "
              style={{ width: "160px" }}
            >
              <div
                className={
                  darkMode ? " d-flex btn-grid-dark " : " d-flex btn-grid "
                }
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Postventa</span>
                </div>
              </div>
            </a>
          </div>

          <img
            className="img-fluid img-qr pb-1"
            src={darkMode ? qrCodigo : qrCodigo}
            alt="codigo qr"
          />
          <div
            className={
              visible1 === true || visible2 === true
                ? "   text-center"
                : " text-center"
            }
          >
            <div className="centrado my-2">
              <button
                onClick={confirmarCerrarSesion}
                style={{ width: "160px" }}
                className={
                  darkMode
                    ? "d-flex  border-0 btn-grid-menu-dark centrado"
                    : "d-flex  border-0 btn-grid-menu centrado"
                }
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faRightFromBracket} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Salir</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </>
    ),
      // Asesores menu
    //
    1: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/check"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/check")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Check</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/simulador"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/simulador")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faChartSimple} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Comparador</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/chat"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/chat")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCommentDots} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Chat</span>
                </div>
              </div>
            </div>
                </NavLink>

            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/asesores/crm"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/asesores/crm")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faTableCells} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">CRM</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/descargas"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/descargas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileArrowDown} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Descargas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/academy"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/academy")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faGraduationCap} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Academy</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/criterios"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/criterios")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCertificate} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Criterios</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/calculadora"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/calculadora")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCalculator} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Simulador</span>
                  {/*<Badge className="custom-badge" bg="danger">*/}
                  {/*  Nuevo*/}
                  {/*</Badge>*/}
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
    // Liquidaciones menu
    2: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Blanqueo</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/Buscador/Cupones"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/Buscador/Cupones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Cupones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/ordenes/pago"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/ordenes/pago")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Orden de pago</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/peticiones"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/peticiones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Peticiones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/facturante"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/facturante")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Factura</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/afip"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/afip")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">IVA-Ganancia</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/iibb"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/iibb")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">IIBB</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/tasas-competencia"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/tasas-competencia")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faTableCells} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Tasas Competencia</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/tasas-zoco"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/tasas-zoco")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faTableCells} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Tasas Zoco</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
      ), // menu administrador/auditor  /Calidad/Historial
      3: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/Admin"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Admin")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Check</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

           
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/AdminPeticiones"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/AdminPeticiones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faListCheck} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Peticiones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/PanelInterno"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/PanelInterno")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel  Gestores</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/PanelControlInterno"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/PanelControlInterno")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel  Interno</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/Historial"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Historial")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Historial CRM</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              {/* <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/Admin"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Admin")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Check</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div> */}
              <div className="centrado my-2">
                <NavLink
                    end
                    to="/Calidad/AdminCRM"
                    className=" border-0"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/Calidad/AdminCRM")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faTableCells} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14"> CRM</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/AdminLegajos"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/AdminLegajos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Legajos</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/AdminNroComercio"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/AdminNroComercio")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Numero Comercio</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Calidad/Auditorias"
                      className=" border-0"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Auditorias")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel Auditorias</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),
      // reclutador menu
    // toda una pagina para la trola esta y se va la muy conchuda
    4: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/busqueda"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/busqueda")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Busqueda</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/contratados"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/contratados")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheckToSlot} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Contratados</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/puestos"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/puestos")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faList} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Puestos</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
      ),  // Menu Pelao
      // Menu para el Pelao
      5: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Inicio</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/MonitoreoDiarioCuit"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/MonitoreoDiarioCuit")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Monitoreo Diario</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/ComerciosRiesgo"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/ComerciosRiesgo")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faChartSimple} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Comercios Riesgo</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/CuitVinculados"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/CuitVinculados")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faLink} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">CUIT Vinculados</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/ReporteMensual"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/ReporteMensual")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Reporte Mensual</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/Fidelizacion"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/Fidelizacion")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Fidelizacion</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/Admin/datosestadisticos"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Admin/datosestadisticos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faChartSimple} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Estadisticas</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/admin/reportesemanal"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/admin/reportesemanal")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Altas y Bajas</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              {/* NUEVO BOTÃ“N */}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/admin/excepcion-anticipo"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/admin/excepcion-anticipo")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Excepcion Anticipo</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),

    // gestor menu
    6: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/check"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/check")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Check</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/academy"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/academy")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faGraduationCap} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Academy</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/peticiones"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/peticiones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Peticiones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        {/* <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/formularios"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={activadoCalificar()}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Formularios</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div> */}
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/simulador"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/simulador")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faChartSimple} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Comparador</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/calculadora"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/calculadora")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCalculator} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Simulador</span>
                  {/*<Badge className="custom-badge" bg="danger">*/}
                  {/*  Nuevo*/}
                  {/*</Badge>*/}
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/descargas"
            className=" border-0 text-decoration-none"
            onClick={ocultarModalesContabilidad}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/descargas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileArrowDown} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Descargas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
      ), 7: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/ZocoConect/Inicio"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/ZocoConect/Inicio")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Inicio</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
            </div>  <div className="centrado my-2">
                <NavLink
                    end
                    to="/ZocoConect/RegistroAliado"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/ZocoConect/RegistroAliado")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Registrarse Zoco Conect</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>  <div className="centrado my-2">
                <NavLink
                    end
                    to="/ZocoConect/Registro"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/ZocoConect/Registro")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Registrar Aliado Zoco Conect</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>  <div className="centrado my-2">
                <NavLink
                    end
                    to="/ZocoConect/AgregarReferidos"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/ZocoConect/AgregarReferidos")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Agregar Referido</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/ZocoConect/ListaUsuariosZocoConect"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/ZocoConect/ListaUsuariosZocoConect")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Lista Usuarios</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),
    // menu administrador/auditor
      8: (
          <>
              {renderSidebarNavLink(crmPostventaLinks[0])}

              <div className="crm-menu-children">
                  {crmPostventaLinks.slice(1).map((item) => renderSidebarNavLink({ ...item, child: true }))}
              </div>

              <div className="centrado my-2">
                  <button
                      type="button"
                      onClick={() => setCrmViejoOpenAdmin((prev) => !prev)}
                      style={{ width: "160px" }}
                      className={`${routeButtonClass(crmViejoPathsAdmin)} border-0 crm-menu-toggle ${crmViejoOpenAdmin ? "is-open" : ""}`}
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faList} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">CRM viejo</span>
                          <span className="crm-menu-caret">{crmViejoOpenAdmin ? "−" : "+"}</span>
                      </div>
                  </button>
              </div>

              {crmViejoOpenAdmin ? (
                  <div className="crm-menu-children crm-menu-children-collapsible">
                      {crmViejoLinksAdmin.map((item) => renderSidebarNavLink({ ...item, child: true }))}
                  </div>
              ) : null}

              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),
      // menu diseÃ±o
      10: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/diseno/notificaciones"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/diseno/notificaciones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Notificaciones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/diseno/popup"
                      className=" border-0 text-decoration-none"
                      onClick={ocultarModalesContabilidad}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/diseno/popup")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Crear Modales</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),

      // Usuario Empleado   faRectangleList
    11: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/cajero/inicio"
            className=" border-0"
            onClick={ocultarModalesInicio}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/cajero/inicio")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faHouse} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Inicio</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/cajero/consultas"
            className=" border-0"
            onClick={ocultarModalesInicio}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/cajero/consultas")}>
                <div className="icono">
                <FontAwesomeIcon icon={faCheckToSlot} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Consultas</span>
                </div>
              </div>
            </div>
          </NavLink>
            </div>

        <div
          className={
            visible1 === true || visible2 === true
              ? " text-center"
              : " text-center"
          }
        >
          <div className="centrado my-2" onClick={ocultarModales}></div>
          <div className="centrado my-2" onClick={ocultarModales}>
            <a
              href="https://wa.link/w4quzx"
              target="_blank"
              rel="noreferrer"
              className=" border-0 "
              style={{ width: "160px" }}
            >
              <div
                className={
                  darkMode ? " d-flex btn-grid-dark " : " d-flex btn-grid "
                }
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Postventa</span>
                </div>
              </div>
            </a>
          </div>

          <img
            className="img-fluid img-qr pb-1"
            src={darkMode ? qrCodigo : qrCodigo}
            alt="codigo qr"
          />
          <div
            className={
              visible1 === true || visible2 === true
                ? "   text-center"
                : " text-center"
            }
          >
            <div className="centrado my-2">
              <button
                onClick={confirmarCerrarSesion}
                style={{ width: "160px" }}
                className={
                  darkMode
                    ? "d-flex  border-0 btn-grid-menu-dark centrado"
                    : "d-flex  border-0 btn-grid-menu centrado"
                }
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faRightFromBracket} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Salir</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </>
    ),
    12:(
        <>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/panelinterno"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/panelinterno")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14"> Panel Interno</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>

            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/blanqueo"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/blanqueo")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faFileInvoiceDollar} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Blanqueo</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/resumenaliado"
                    className=" border-0 text-decoration-none"
                    onClick={ocultarModalesContabilidad}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/resumenaliado")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Resumen Aliado</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>  
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/comparador"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/comparador")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faChartSimple} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Simulador</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>

            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/simulador"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/simulador")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faCalculator} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Comparador</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/simuladorliquidaciones"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/simuladorliquidaciones")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faCalculator} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Simulador Liquidaciones</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/ordenpago"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/ordenpago")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faCalculator} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Orden de Pago</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>

            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/cupones"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/cupones")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Cupones</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/nrocomercio"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/nrocomercio")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">NÂ° de Comercio</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/legajos"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/abmtest/legajos")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Legajos</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            {/* <div className="centrado my-2">
                <NavLink
                    end
                    to="/abmtest/crm"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={activado()}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faTableCells} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">CRM</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div> */}

            <div className="centrado my-2">
                <button
                    onClick={confirmarCerrarSesion}
                    style={{ width: "160px" }}
                    className={
                        darkMode
                            ? "d-flex  border-0 btn-grid-menu-dark centrado"
                            : "d-flex  border-0 btn-grid-menu centrado"
                    }
                >
                    <div className="icono">
                        <FontAwesomeIcon icon={faRightFromBracket} />
                    </div>
                    <div className="texto">
                        <span className="lato-bold fs-14">Salir</span>
                    </div>
                </button>
            </div>
        </>

    ),
    13: (
        <>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/compliance/panel"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/compliance/panel")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faCertificate} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Compliance</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/compliance/informe-uif"
                    className="border-0"
                    onClick={ocultarModalesInicio}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/compliance/informe-uif")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faFileLines} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">Informe UIF</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>

            <div className="centrado my-2">
                <button
                    onClick={confirmarCerrarSesion}
                    style={{ width: "160px" }}
                    className={
                        darkMode
                            ? "d-flex  border-0 btn-grid-menu-dark centrado"
                            : "d-flex  border-0 btn-grid-menu centrado"
                    }
                >
                    <div className="icono">
                        <FontAwesomeIcon icon={faRightFromBracket} />
                    </div>
                    <div className="texto">
                        <span className="lato-bold fs-14">Salir</span>
                    </div>
                </button>
            </div>
        </>

    ),
    // meta panel menu
    20: (
      <>
        <div className="centrado my-2">
          <NavLink end to="/meta/inicio" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/meta/inicio")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faHouse} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Inicio</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/meta/leads" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/meta/leads")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Leads</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/meta/campanas" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/meta/campanas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faChartSimple} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Campañas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/meta/paginas" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/meta/paginas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faNewspaper} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Páginas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/meta/conexion" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/meta/conexion")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faLink} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Configuración</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        {/* Zoco Meta */}
        <div className="centrado mt-3 mb-1">
          <div style={{ width: "160px", textAlign: "center" }}>
            <span style={{ fontSize: "0.63rem", fontWeight: 700, color: "#888", letterSpacing: 1, textTransform: "uppercase" }}>
              — Zoco Meta —
            </span>
          </div>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/resumen" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/resumen")}>
                <div className="icono"><FontAwesomeIcon icon={faHouse} /></div>
                <div className="texto"><span className="lato-bold fs-14">Resumen</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/campanas" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass(["/zocometa/campanas", "/meta/campanaszt"])}>
                <div className="icono"><FontAwesomeIcon icon={faChartSimple} /></div>
                <div className="texto"><span className="lato-bold fs-14">Campañas ZT</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/leads" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/leads")}>
                <div className="icono"><FontAwesomeIcon icon={faListCheck} /></div>
                <div className="texto"><span className="lato-bold fs-14">Leads CRM</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/audiencias" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/audiencias")}>
                <div className="icono"><FontAwesomeIcon icon={faUser} /></div>
                <div className="texto"><span className="lato-bold fs-14">Audiencias</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/auditoria" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/auditoria")}>
                <div className="icono"><FontAwesomeIcon icon={faMagnifyingGlassChart} /></div>
                <div className="texto"><span className="lato-bold fs-14">Auditoría</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/closers" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/closers")}>
                <div className="icono"><FontAwesomeIcon icon={faMagnifyingGlassChart} /></div>
                <div className="texto"><span className="lato-bold fs-14">Closers</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/ubicaciones" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/ubicaciones")}>
                <div className="icono"><FontAwesomeIcon icon={faList} /></div>
                <div className="texto"><span className="lato-bold fs-14">Ubicaciones</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/carga" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/carga")}>
                <div className="icono"><FontAwesomeIcon icon={faCheckToSlot} /></div>
                <div className="texto"><span className="lato-bold fs-14">Carga</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink end to="/zocometa/ia" className="border-0" onClick={ocultarModalesInicio}>
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/zocometa/ia")}>
                <div className="icono"><FontAwesomeIcon icon={faStar} /></div>
                <div className="texto"><span className="lato-bold fs-14">Recomendaciones IA</span></div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={darkMode ? "d-flex border-0 btn-grid-menu-dark centrado" : "d-flex border-0 btn-grid-menu centrado"}
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
  };

  const menuActual = menusPorRol[usuarioRol] || <></>;


  function PopoverBottom() {
    const popover = (
      <Popover
        className={
          darkMode
            ? "caja-campana-dark scroll-especifico-dark text-white"
            : "caja-campana scroll-especifico "
        }
        id="popover-positioned-bottom"
      >
        <Popover.Body>
          {usuarioRol === 0 ? (
            <>
              <div className="container px-4">
                <div className="d-flex flex-column justify-content-around">
                  {notificacionesAliados.map((notificacion, index) => (
                    <div key={index}>
                      <h6 className="fs-16 my-3">
                        <span className="me-2">
                          {darkMode ? (
                            <FontAwesomeIcon
                              className="fs-8  color-blanco-items"
                              icon={faCircle}
                            />
                          ) : (
                            <FontAwesomeIcon
                              className="fs-8  color-negro-items"
                              icon={faCircle}
                            />
                          )}
                        </span>
                        <span
                          className={darkMode ? "text-white" : "text-black"}
                        >
                          {notificacion.noticia1}
                        </span>
                      </h6>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="container px-4">
                <div className="d-flex flex-column justify-content-around">
                  {notificacionesAsesores.map((notificacion, index) => (
                    <div key={index}>
                      <h6 className="fs-16 my-3">
                        <span className="me-2">
                          {darkMode ? (
                            <FontAwesomeIcon
                              className="fs-8  color-blanco-items"
                              icon={faCircle}
                            />
                          ) : (
                            <FontAwesomeIcon
                              className="fs-8  color-negro-items"
                              icon={faCircle}
                            />
                          )}
                        </span>
                        <span
                          className={darkMode ? "text-white" : "text-black"}
                        >
                          {notificacion.noticia1}
                        </span>
                      </h6>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
        <FontAwesomeIcon
          onClick={() => {
            verModalNotificacion();
            setVisible2(false);
            setHayNotificacionesNoVistas(false);
          }}
          className={activadoIconoCampana()}
          icon={faBell}
        />
      </OverlayTrigger>
    );
  }

  function PopoverBottom2() {
    const popover = (
      <Popover
        className={
          darkMode
            ? "caja-cerrar-sesion-dark centrado"
            : "caja-cerrar-sesion centrado"
        }
        id="popover-positioned-bottom"
      >
        <Popover.Body>
          <div className="container">
            <div className="py-4">
              <h6
                className={
                  darkMode
                    ? "fs-18 lato-bold text-white my-3 text-center"
                    : "fs-18 lato-bold my-3 text-center"
                }
              >
                Zoco SAS
              </h6>
              <div>
                <div className="centrado my-3">
                  <Button
                    className={
                      darkMode
                        ? "d-flex btn-nav-configuracion-dark  centrado border-0"
                        : "d-flex btn-nav-configuracion centrado  border-0"
                    }
                    onClick={() => setModalShowCompleta(true)}
                  >
                    <FontAwesomeIcon className="" icon={faGear} />
                    <span className="ms-2  lato-bold fs-10">
                      Cambiar Contraseña
                    </span>
                  </Button>
                  <ModalConfiguraciones
                    show={modalShowCompleta}
                    onHide={() => setModalShowCompleta(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
        {darkMode ? (
          <FontAwesomeIcon className={activadoIconoUser()} icon={faUser} />
        ) : (
          <FontAwesomeIcon
            onClick={() => {
              setVisible2(false);
            }}
            className={activadoIconoUser()}
            icon={faUser}
          />
        )}
      </OverlayTrigger>
    );
  }

  return (
    <>
      <section className={darkMode ? `sidebar-dark sidebar-clean${sidebarCollapsed ? " is-collapsed" : ""}` : `sidebar sidebar-clean${sidebarCollapsed ? " is-collapsed" : ""}`}>
        <div className="py-5 text-center sidebar-brand-block">
          <div className="sidebar-collapse-row">
            <button
              type="button"
              className="sidebar-collapse-button"
              onClick={() => setSidebarCollapsed((prev) => !prev)}
              title={sidebarCollapsed ? "Expandir navegación" : "Colapsar navegación"}
              aria-label={sidebarCollapsed ? "Expandir navegación" : "Colapsar navegación"}
            >
              <FontAwesomeIcon icon={sidebarCollapsed ? faAnglesRight : faAnglesLeft} />
            </button>
          </div>
          <img
            className="my-4 img-fluid sidebar-brand-logo"
            src={darkMode ? logoClaro : logo}
            alt="logo"
            width="140"
            height="40"
          />
          <div className="d-flex justify-content-center mt-3 sidebar-brand-actions">
            <div className="zoom">
              <FontAwesomeIcon
                onClick={handleClick}
                className="iconos-modales color-verde mx-3"
                icon={darkMode ? faSun : faMoon}
              />
            </div>

            <div className="zoom" style={{ position: "relative" }}>
              {hayNotificacionesNoVistas && (
                <NotificacionIndicador count={"!"} />
              )}
              {PopoverBottom()}
            </div>
            <div className="zoom">{PopoverBottom2()}</div>
          </div>
        </div>
        {menuActual}
      </section>
    </>
  );
};

export default SidebarReact;


